var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg_containner"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://cdn-file.xiaojudai.cn/web/dist/haiguanCheck/hg_pic1.png","alt":""}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://cdn-file.xiaojudai.cn/web/dist/haiguanCheck/hg_pic2.png","alt":""}})])
}]

export { render, staticRenderFns }